import ShortRestPane from './ShortRestPane';

export default ShortRestPane;
export { ShortRestPane };
